import type { FC } from 'react'

type Props = {
  children: React.ReactNode
}

const EvaluationResultContent: FC<Props> = ({ children }) => {
  return (
    <section className="flex flex-col gap-6 max-w-3xl p-9">{children}</section>
  )
}

export default EvaluationResultContent
